const DAYS = ["Sonntag", "Montag", "Dienstag", "Mittwoch", "Donnerstag", "Freitag", "Samstag"];
const SHORT = ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"];

const fmt = (m) => `${String(Math.floor(m / 60)).padStart(2, "0")}:${String(m % 60).padStart(2, "0")}`;

function parseRanges(timeStr) {
  if (!timeStr) return [];
  const out = [];
  for (const part of timeStr.split(/[·,]/)) {
    const m = part.match(/(\d{1,2})[:.](\d{2})\s*[–—-]\s*(\d{1,2})[:.](\d{2})/);
    if (m) out.push([+m[1] * 60 + +m[2], +m[3] * 60 + +m[4]]);
  }
  return out;
}

export function getTodayHoliday(holidays) {
  if (!Array.isArray(holidays)) return null;
  const today = new Date().toISOString().slice(0, 10);
  return holidays.find((h) => h.date === today) || null;
}

export function getUpcomingHolidays(holidays, limit = 6) {
  if (!Array.isArray(holidays)) return [];
  const today = new Date().toISOString().slice(0, 10);
  return holidays.filter((h) => h.date >= today).sort((a, b) => a.date.localeCompare(b.date)).slice(0, limit);
}

export function getActiveHours(content) {
  let season = content?.season || "auto";
  if (season === "auto") {
    const now = new Date();
    const md = `${String(now.getMonth() + 1).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")}`;
    const summerStart = (content?.seasonSummerStart || "2026-04-01").slice(-5);
    const winterStart = (content?.seasonWinterStart || "2026-11-01").slice(-5);
    const inSummer =
      summerStart <= winterStart
        ? md >= summerStart && md < winterStart
        : md >= summerStart || md < winterStart;
    season = inSummer ? "sommer" : "winter";
  }
  const hours = season === "sommer" ? content.hoursSummer || content.hours : content.hours;
  return { hours, season, label: season === "sommer" ? "Sommerzeit" : "Winterzeit" };
}

export function getOpenStatus(hours) {
  if (!Array.isArray(hours)) return { open: false, label: "" };
  const now = new Date();
  const mins = now.getHours() * 60 + now.getMinutes();
  const todayIdx = now.getDay();
  const byDay = (idx) => hours.find((h) => h.day === DAYS[idx]);

  const todayH = byDay(todayIdx);
  if (todayH && !todayH.closed) {
    const ranges = parseRanges(todayH.time);
    for (const [s, e] of ranges) {
      if (mins >= s && mins < e) {
        const soon = e - mins <= 30;
        return { open: true, label: soon ? `Öffnet bald · bis ${fmt(e)}` : `Jetzt geöffnet · bis ${fmt(e)}`, soon };
      }
    }
    const next = ranges.map((r) => r[0]).filter((s) => s > mins).sort((a, b) => a - b)[0];
    if (next !== undefined) return { open: false, label: `Heute ab ${fmt(next)}` };
  }

  for (let i = 1; i <= 7; i++) {
    const idx = (todayIdx + i) % 7;
    const h = byDay(idx);
    if (h && !h.closed) {
      const ranges = parseRanges(h.time);
      if (ranges.length) return { open: false, label: `Geöffnet ${SHORT[idx]} ab ${fmt(ranges[0][0])}` };
    }
  }
  return { open: false, label: "Zurzeit geschlossen" };
}
